export default {
  fieldNames: {
      preference: "Preference",
      partNumber: "Part Number",
      reorderPoint: "Reorder Point",
      reorderQuantity: "Reorder Quantity",
      minimumStock: "Minimum Stock",
      analystName: "Analyst Name",
      purchasingOfficer: "Purchasing Officer",
  },
  analyst: "Analyst",
  applicant: "Applicant",
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/analystView.js